module.exports = __webpack_public_path__ + "static/media/question_box.eb762eb6.svg";